<template>
  <div class="book ">
    <div class="middle-main">
      <h1 class="title">好書推薦</h1>
      <book-list class="book-lists" :magazineList="magazineListRes" />
      <div class="justify-center" style="padding-bottom: 50px; margin-top: 30px">
          <pagination :current-page="pageNum" :page-size="pageSize" :total="total" @changeSize="changeSize" />
        </div>
    </div>

  </div>
</template>

<script>
import { mapState } from "vuex";
import ColumnTitle from "../common/column-title.vue";
import pagination from "../common/pagination.vue";
import { getMagazineList } from "@/assets/api/magazine.js";
import bookList from "../common/book-list.vue";
export default {
  components: {
    ColumnTitle,
    pagination,
    bookList,
  },
  data() {
    return {
      tabs: [
        {
          name: "全部",
          id: "1",
        },
        {
          name: "2025年刊",
          id: "2",
        },
        {
          name: "2024年刊",
          id: "3",
        },
        {
          name: "2023年刊",
          id: "4",
        },
        // {
        //   name: "2022",
        //   id: "4",
        // },
        // {
        //   name: "2021",
        //   id: "5",
        // },
        // {
        //   name: "2020",
        //   id: "6",
        // },
        // {
        //   name: "2019",
        //   id: "7",
        // },
      ],
      magazineListRes: [],
      total: 0,
      pageNum: 1,
      pageSize: 12,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const data = {
        orderByColumn: "releaseTime",
        isAsc: "desc",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        goodsTypeDict: 2,
      }
      const formData = new FormData();
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          formData.append(key, data[key]);
        }
      }
      getMagazineList(formData).then((res) => {
        // console.log(res.data);
        this.total = res.data.total;
        this.magazineListRes = res.data.rows.map((item) => {
          item.image = item.image.split(",");
          item.image = item.image.map((it) => {
            it = !/^http/.test(it) ? this.$imgUrl + it : it;
            return it;
          });
          item.image = item.image[0];
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    openOrder() {
      this.$router.push({
        path: `/order`,
      });
    }
  },
};
</script>

<style lang="less" scoped>
.book {
  // padding-top: 80px;
  .title {
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 32px;
    color: #2C2C2E;
    line-height: 42px;
    text-align: left;
    font-style: normal;
    margin: 40px 0 30px;
  }
  .book-lists {
    margin-top: 15px;
  }
}
.line {
  width: 100%;
  height: 1px;
  background-color: #E5E5EA;
  margin: 60px 0 30px;
}
.other-news {
  padding: 40px 0 80px;
}
@media (max-width: 768px) {
  .book {
    padding: 30px 20px;
  }
  .magazine-subscription{
    // padding: 0 10px;
  }
  .line{
    margin: 48px 0 40px;
  }
}
</style>
<style>
.book .el-tabs--card>.el-tabs__header .el-tabs__nav {
  justify-content: flex-start;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/book/index.vue